import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

//create action
export const updateSop = createAsyncThunk("updateSop", async ({ id, data }) => {
	const token = localStorage.getItem("auth_token");
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};
	const response = await axiosHttp.patch(`sop/update?id=${id}`, data, config);
	message.success(response.data.message);
	return response.data;
});

const SopUpdateSlice = createSlice({
	name: "SopUpdateSlice",
	initialState: {
		isLoading: false,
		error: null,
	},

	reducers: {
		resetUpdateState: (state) => {
			state.isLoading = false;
			state.error = false;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(updateSop.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(updateSop.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(updateSop.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export const { resetUpdateState } = SopUpdateSlice.actions;
export default SopUpdateSlice.reducer;
